import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
const ItJobsGurugram = () => {
  return (
    <>
    <Navbar/>
    <div className="container mx-auto px-4 py-12 text-gray-700">
      <Helmet>
        <title>{"IT Jobs in Gurugram | Latest Software & Tech Openings 2025"}</title>
        <meta
          name="description"
          content="Find the latest IT jobs in Gurugram for software developers, engineers, testers, and data analysts. Apply now for top tech openings in Gurugram NCR."
        />
        <meta
          name="keywords"
          content="IT jobs in Gurugram, software jobs in Gurugram, web developer jobs Gurugram, tech jobs in Gurugram NCR, fresher IT jobs in Gurugram"
        />
      </Helmet>

      {/* Page Title */}
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        IT Jobs in Gurugram – Latest Openings {new Date().getFullYear()}
      </h1>

      {/* Intro Paragraph */}
      <p className="mb-6 leading-relaxed">
        Looking for the best <strong>IT jobs in Gurugram</strong>? Gurugram  is one of India’s top
        technology hubs offering a wide range of opportunities in software development, web
        designing, data analysis, and cloud computing. Whether you’re a fresher or an experienced
        professional, explore hundreds of verified openings in Gurugram-based tech companies.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        Top IT Companies Hiring in Gurugram
      </h2>
      <ul className="list-disc list-inside mb-6 space-y-1">
        <li>Infosys</li>
        <li>Tech Mahindra</li>
        <li>HCL Technologies</li>
        <li>Tata Consultancy Services (TCS)</li>
        <li>Wipro</li>
        <li>Accenture</li>
        <li>Deloitte</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        Popular IT Job Roles in Gurugram
      </h2>
      <ul className="list-disc list-inside mb-6 space-y-1">
        <li>Software Developer / Engineer</li>
        <li>Front-end / React.js Developer</li>
        <li>Backend Developer (Node.js, Python, Java)</li>
        <li>Full Stack Developer</li>
        <li>Data Analyst / Data Engineer</li>
        <li>DevOps Engineer</li>
        <li>QA Tester / Automation Engineer</li>
         <li>Associate Technical Engineer</li>
          <li> IT Specialist</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        IT Jobs for Freshers in Gurugram
      </h2>
      <p className="mb-6">
        Many startups and MNCs in Gurugram offer entry-level opportunities for computer science and IT
        graduates. Companies like HCL, Wipro, and Tech Mahindra regularly hire freshers for
        trainee-level software engineering roles with on-job training.
      </p>

      
    </div>
    <Footer/>
    </>
  );
};

export default ItJobsGurugram;
